var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1510_8599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.22 20.726C22.1419 20.7154 22.0623 20.7239 21.9883 20.7509C21.9142 20.7779 21.8479 20.8226 21.795 20.881C21.7412 20.9384 21.7017 21.0078 21.6798 21.0834C21.6579 21.159 21.6542 21.2387 21.669 21.316C21.945 22.766 22.874 24.756 25.726 25.995C26.064 26.141 26.586 26.255 27.248 26.398C29.726 26.934 33.87 27.832 34.888 31.63C34.905 31.6935 34.9345 31.753 34.9745 31.8051C35.0146 31.8573 35.0645 31.901 35.1215 31.9338C35.1785 31.9666 35.2414 31.9879 35.3065 31.9965C35.3717 32.005 35.438 32.0006 35.5015 31.9835C35.565 31.9664 35.6245 31.937 35.6766 31.897C35.7287 31.8569 35.7725 31.8069 35.8053 31.75C35.8381 31.693 35.8594 31.6301 35.8679 31.5649C35.8764 31.4997 35.872 31.4335 35.855 31.37C34.678 26.983 29.983 25.966 27.46 25.42C26.876 25.293 26.371 25.184 26.124 25.076C24.41 24.332 23.303 23.228 22.823 21.79C27.585 22.144 29.741 20.247 29.836 20.161C29.8945 20.108 29.9397 20.0418 29.9678 19.9679C29.9958 19.8941 30.006 19.8146 29.9974 19.7361C29.9888 19.6575 29.9617 19.5821 29.9184 19.5161C29.875 19.45 29.8166 19.3951 29.748 19.356C27 17.786 27 12.361 27 10.318C27 4.60501 23.152 0.0760142 18.219 0.00501416C18.172 0.00345005 18.125 0.00244998 18.078 0.00201416H18.077C13.072 0.0300142 8.99997 4.56401 8.99997 10.11C8.99997 12.153 8.99997 17.579 6.25197 19.148C6.18113 19.1892 6.12142 19.247 6.07801 19.3165C6.03461 19.3859 6.00883 19.465 6.00292 19.5467C5.997 19.6284 6.01113 19.7103 6.04408 19.7853C6.07703 19.8603 6.1278 19.9261 6.19197 19.977C6.32997 20.084 9.37997 22.418 13.133 21.709C12.631 23.087 11.539 24.147 9.87497 24.87C9.63397 24.975 9.15397 25.09 8.59797 25.222C6.05797 25.826 1.32897 26.951 0.144972 31.369C0.127966 31.4325 0.123632 31.4987 0.132219 31.5639C0.140805 31.6291 0.162144 31.6919 0.195015 31.7488C0.261403 31.8638 0.37074 31.9477 0.498972 31.982C0.627204 32.0164 0.763828 31.9984 0.878788 31.932C0.993748 31.8656 1.07763 31.7562 1.11197 31.628C2.14097 27.784 6.32897 26.789 8.82997 26.193C9.45697 26.044 9.95197 25.926 10.274 25.787C13.126 24.548 14.054 22.558 14.331 21.108C14.3474 21.0231 14.3414 20.9353 14.3135 20.8534C14.2856 20.7715 14.2368 20.6983 14.172 20.641C14.1076 20.5832 14.0293 20.5433 13.9448 20.525C13.8602 20.5068 13.7724 20.5109 13.69 20.537C10.983 21.389 8.48197 20.217 7.38897 19.567C9.99997 17.381 9.99997 12.35 9.99997 10.11C9.99997 5.11301 13.626 1.02701 18.12 1.00001L18.226 1.00601C22.658 1.06901 26 5.07201 26 10.318C26 12.559 26 17.601 28.622 19.787C27.719 20.303 25.66 21.138 22.22 20.726Z",
    fill: "#292561"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1510_8599",
    x: -3.87207,
    y: 0.00201416,
    width: 43.7441,
    height: 39.9987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1510_8599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1510_8599",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.da98fb5b7d948f47b5476225ff17c28e.svg";
export { ForwardRef as ReactComponent };